import {listingsLoading, LISTINGS_LOADING} from '../../actions/pagedListings/load-listings-paged';
import { ActionType } from 'typesafe-actions';

export type ListingsLoadingAction = ActionType<typeof listingsLoading>;

export default (state = false, action: ListingsLoadingAction) => {
    switch(action.type){     
        case LISTINGS_LOADING:
            return action.payload;
        default:
            return state;
    }
}